const basketActions = document.querySelectorAll('.js-basket-actions')
const basketForm = document.getElementById('js-basket-form')

if (basketActions.length) {
  basketActions.forEach((action) => {
    const input = action.querySelector('input')
    input.addEventListener('change', () => {
      basketForm.submit()
    })

    const removeButton = action.querySelector('.basket-page__remove')
    removeButton.addEventListener('click', () => {
      input.value = 0
      basketForm.submit()
    })

    const minusButton = action.querySelector(
      '.add-to-basket__amount-btn:first-of-type'
    )
    minusButton.addEventListener('click', () => {
      input.value = parseInt(input.value) - 1
      basketForm.submit()
    })

    const plusButton = action.querySelector(
      '.add-to-basket__amount-btn:last-of-type'
    )
    plusButton.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1
      basketForm.submit()
    })
  })

  const country = document.getElementById('del_country_id')
  if (country) {
    country.addEventListener('change', () => {
      basketForm.submit()
    })
  }

  const pointInput = document.getElementById('use_points')
  const pointInputHidden = document.getElementById('use_points_hidden')
  const pointIndicator = document.getElementById('using_points')
  const pointWarning = document.getElementById('use_points_warning')
  if(pointInput) {
    
    pointInput.addEventListener('input', () => {
      pointIndicator.innerText = pointInput.value

      if(pointInput.value < 500) {
        pointWarning.style.display = 'block'
      } else {
        pointWarning.style.display = 'none'
      }
    })

    pointInput.addEventListener('change', () => {
      if(pointInput.value >= 500) {
        pointInputHidden.value = pointInput.value
        
        setTimeout(() => {
          basketForm.submit()
        }, 100)
      } else {
        if(pointInputHidden.value !== "0") {
          setTimeout(() => {
            basketForm.submit()
          }, 100)
        }
        pointInputHidden.value = 0
      }
    })
  }
}

const discountTrigger = document.querySelector('.basket-page__discount-trigger')
const discountContent = document.querySelector('.basket-page__discount-content')

if (discountTrigger) {
  discountTrigger.addEventListener('click', () => {
    discountTrigger.classList.toggle('basket-page__discount-trigger--open')
    discountContent.classList.toggle('basket-page__discount-content--open')
  })
}
